import {
  MEASUREMENT_TYPE_ALL,
  MEASUREMENT_TYPE_GET,
  MEASUREMENT_TYPE_DELETE,
  MEASUREMENT_TYPE_PUT,
  MEASUREMENT_TYPE_POST,
  MEASUREMENT_TYPE_LOADING,
  MEASUREMENT_TYPE_ERROR,
} from '../types';

import api from '../../../configs/api';

export const measurementTypeCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: MEASUREMENT_TYPE_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/measurement-type`,
      {
        ...payload,
      },
    );
    dispatch({ type: MEASUREMENT_TYPE_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: MEASUREMENT_TYPE_ERROR });
    throw new Error(error);
  }
};

export const measurementTypeAll = ({
  name = '',
  size = '',
  page = 1,
}) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/measurement-type?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: MEASUREMENT_TYPE_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: MEASUREMENT_TYPE_ERROR });
    throw new Error(error);
  }
};

export const measurementTypeGet = (id) => async (dispatch) => {
  try {
    dispatch({ type: MEASUREMENT_TYPE_LOADING });
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/measurement-type/${id}`,
    );
    if (status === 200) {
      dispatch({ type: MEASUREMENT_TYPE_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: MEASUREMENT_TYPE_ERROR });
    throw new Error(error);
  }
};

export const measurementTypeStateSet = (data) => async (dispatch) => {
  dispatch({ type: MEASUREMENT_TYPE_ALL, payload: data });
};

export const measurementTypePut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: MEASUREMENT_TYPE_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/measurement-type/${id}`,
      payload,
    );
    dispatch({ type: MEASUREMENT_TYPE_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: MEASUREMENT_TYPE_ERROR });
    throw new Error(error);
  }
};

export const measurementTypeStateOneSet = (data) => async (dispatch) => {
  dispatch({ type: MEASUREMENT_TYPE_GET, payload: data });
};

export const measurementTypeDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: MEASUREMENT_TYPE_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/measurement-type/${id}`,
    );
    dispatch({ type: MEASUREMENT_TYPE_DELETE, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: MEASUREMENT_TYPE_ERROR });
    throw new Error(error);
  }
};

export const measurementTypeLoading = () => async (dispatch) => {
  dispatch({ type: MEASUREMENT_TYPE_LOADING });
};
